//unnamed function export example
module.exports = function() {
  //console.log('My component example!');
}();